import React, { useEffect, createContext, useRef, useState } from "react"

const WebSocketContext = createContext(false, null, () => { })

function WebSocketProvider({ children, jeTester }) {
    const [isReady, setIsReady] = useState(false)
    const [val, setVal] = useState(null)
    const ws = useRef(null)
    const reconnect = useRef(true)
    const reconnectAttempts = useRef(0);
    const [connectionError, setConnectionError] = useState(false)


    useEffect(() => {

        connect();

        return () => {
            reconnect.current = false;
            ws.current.close();
        }
    }, [])

    const socket = [isReady, val, ws.current?.send.bind(ws.current), connectionError]

    function connect() {
        reconnect.current = true;

        ws.current = new WebSocket(casino.config.IHGWidgetScriptURL)
        ws.current.onmessage = (event) => {
            return setVal(event.data)
        }
        ws.current.onopen = () => {
            console.log('WS open');
            reconnectAttempts.current = 0;
            setConnectionError(false);
            setIsReady(true);
        }
        ws.current.onclose = () => {
            console.log('WS close');
            setIsReady(false)
            if (reconnect.current) {
                tryReconnect();
            }
        }
        ws.current.onerror = () => {
            console.log('WS error');
            setConnectionError(true);

        }
    }

    function tryReconnect() {
        //trying to reconnect 5 times after 2,4,6,8,10 sec
        setTimeout(() => {
            if (reconnectAttempts.current < 5) {
                reconnectAttempts.current++;
                connect();
            }
        }, (1 + reconnectAttempts.current) * 2000)

    }


    return (
        <WebSocketContext.Provider value={socket}>
            {children}
        </WebSocketContext.Provider>
    )
}

export { WebSocketContext, WebSocketProvider }